import { useContext, useReducer } from "react";
import { Outlet } from "react-router-dom";
import { sponsorsReducer } from "./sponsorsReducer";
import { sponsorsInitialState } from "./sponsorsInitialState";
import SponsorsContext from "./SponsorsContext";


export const useSponsorsContext = () => useContext(SponsorsContext)


export function SponsorsProvider() {
    const [sponsorsState, sponsorsDispatch] = useReducer(
        sponsorsReducer,
        sponsorsInitialState
    )

    return (
        <SponsorsContext.Provider value={{ sponsorsState, sponsorsDispatch }}>
            <Outlet />
        </SponsorsContext.Provider>
    )
}
